import React from "react";
import { Card, makeStyles } from "@material-ui/core";
import IconPdf from '../../assets/pdfIcon.png'

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 5,
    padding: "5px 5px",
    width: "100%",
    height: "auto",
    boxShadow: "2px 2px 20px black",
    display: "flex",
    justifyContent: "center",

  },
  cardInside: {

    height: 120,
    display: "flex",
    justifyContent: "center",
  },
}));

export default React.forwardRef(function CarouselSlide(props, ref) {
  const classes = useStyles();

  const { url, nombreDocumento, idItem } = props.content;

  const validarPDF = (url) => {
    let result = url.search(".pdf");
    return result;
  }
  
  return (
    <Card key={idItem} className={classes.card} >
      <div className={classes.cardInside}>
        <img style={{ maxWidth: "100%", maxHeight: "100%", }} alt="" src={validarPDF(nombreDocumento) === -1 ? `${process.env.REACT_APP_URL}/${url}${nombreDocumento}` : IconPdf} />
      </div>
    </Card>
  );
})
